/**
 * PorCobrarPage — Reservas con saldo > 0 pendiente de cobro.
 */
import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ReservacionesTable from './shared/ReservacionesTable';
import ReservaSlideOver from './ReservaSlideOver';
import { categorizar } from './shared/useReservaciones';
import { formatPrecio, todayLocal } from './shared/format';
import { exportarReservasCSV } from './shared/exportCSV';

export default function PorCobrarPage() {
  const { reservaciones, isLoading, refetch } = useOutletContext();
  const [detalleId, setDetalleId] = useState(null);

  const { porCobrar } = categorizar(reservaciones);

  const totalPendiente = useMemo(
    () => porCobrar.reduce((acc, r) => acc + Number(r.saldo_pendiente || 0), 0),
    [porCobrar]
  );

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Por cobrar</Typography>
          <Typography sx={{ fontSize: 12, color: '#64748b' }}>
            {porCobrar.length} {porCobrar.length === 1 ? 'reserva' : 'reservas'} con saldo pendiente.
          </Typography>
        </Box>
        <Button variant="outlined" startIcon={<DownloadIcon />} size="small"
          disabled={porCobrar.length === 0}
          onClick={() => exportarReservasCSV(porCobrar, `reservas-por-cobrar-${todayLocal()}.csv`)}
          sx={{ textTransform: 'none', fontWeight: 600, color: '#0f766e', borderColor: '#0f766e' }}>
          CSV ({porCobrar.length})
        </Button>
        <Paper sx={{ px: 2, py: 1, bgcolor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 2 }}>
          <Typography sx={{ fontSize: 10, color: '#9a3412', fontWeight: 700, textTransform: 'uppercase' }}>
            Total pendiente
          </Typography>
          <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#9a3412' }}>
            {formatPrecio(totalPendiente)}
          </Typography>
        </Paper>
      </Box>

      <ReservacionesTable
        rows={porCobrar}
        loading={isLoading}
        onRowClick={r => setDetalleId(r.id)}
        showSaldo
        defaultSortBy="saldo"
        defaultSortDir="desc"
        emptyTitle="Sin saldos pendientes"
        emptyMessage="Cuando una reserva tenga saldo > 0, aparecerá aquí."
      />

      {detalleId && (
        <ReservaSlideOver reservaId={detalleId}
          onClose={() => setDetalleId(null)} onUpdated={refetch} />
      )}
    </Box>
  );
}
